export type ClockPartnerCard = {
  id: number;
  person?: {
    firstName?: string;
    lastName?: string;
    secondLastName?: string;
  } | null;
  message?: {
    title?: string;
    message?: string;
    duration?: number;
    icon?: string;
  } | null;
};

export function readClockPartner(response: unknown): ClockPartnerCard | undefined {
  if (!response || typeof response !== "object") return undefined;
  const card = (response as { clockPartner?: ClockPartnerCard }).clockPartner;
  if (!card || typeof card.id !== "number") return undefined;
  return card;
}
